<template>
  <div class="page">
   <div class="bg-white " style="height: calc(100%);">
    <el-card>
      
      <el-form size="small"  class="" ref="searchForm" :model="detForm">
        <el-row>
          <el-col :span="8">
            <el-form-item prop="" label="项目编号：">
              <span>{{ detForm.project.proCode }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="" label="项目名称：">
              <span>{{ detForm.project.name }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="" label="项目单价：">
              <span>$ {{ $mathUtil.mathToFixed(detForm.price) }} / {{ detForm.unitEn }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="" label="项目备注信息：">
              <span>{{ detForm.description }}</span> 
            </el-form-item>
          </el-col>
          <!-- <el-col :span="24">
          <el-form-item label="封面" prop="">
                 <CropperView ref="cropperviewRef" 
                 :imgSrc="detForm.cover" 
                 :autoCropWidth="88"
                 :autoCropHeight="88" 
                 :disabled="true"  
                 :actionButtonFlag="true" 
                 :objectFit="'cover'" 
                 :listIndex="1" 
                 @updateChange="changeImage($event,detForm)">
                 </CropperView>
           </el-form-item>
        </el-col> -->
        <el-col :span="24">
          <el-form-item label="项目图片：" prop="">
            <div class="flex-row flex-w">
              <el-image v-for="item in detForm.picJsonList" :key="item.id" :src="item.fileUrl" style="width: 100px;height:100px;margin:0 10px 10px 0" :preview-src-list="srcList"></el-image>
            </div>
           </el-form-item>
        </el-col>
        </el-row>
      </el-form>
    </el-card>
      <div class="tableTitle">材料方案：</div>
      <div style="min-height: calc(50% - 20px);">
      <vxe-table
          border="full"
          auto-resize
          resizable
          height="auto"
          :loading="loading"
          size="small"
          ref="cecUnmSetsTable"
          show-header-overflow
          show-overflow
          highlight-hover-row
          :menu-config="{}"
          :print-config="{}"
          :import-config="{
              types: ['csv', 'xls', 'xlsx'],
              remote: true,
          }"
          @sort-change="sortChangeHandle"
          :sort-config="{remote:true}"
          :data="dataList"
          :checkbox-config="{}">
          <!-- <vxe-column type="seq" width="40"></vxe-column> -->
          <!-- <vxe-column type="checkbox"  width="40px"></vxe-column> -->
          <!-- <vxe-column
      field="sort"
      width="50px"
      title="排序">
    </vxe-column> -->
    <vxe-column
      field="isMain"
      width="100"
      align="center"
      title="材料使用">
        <template slot-scope="scope">
          <span>{{ scope.row.mateKind }}</span>   
        </template>
    </vxe-column>
    <vxe-column
      field="code"
      align="center"
      width="100"
      title="物品编码">
        <template slot-scope="scope">
            <!-- <el-link  type="primary" :underline="false" v-if="hasPermission('unmsets:cecUnmSets:edit')" @click="edit(scope.row.id)">{{scope.row.nameCn}}</el-link> -->
            <el-link  type="primary" :underline="false" v-if="hasPermission('cecunmusersetmeal:cecUnmUserSetMeal:view')"  @click="view(scope.row)">{{scope.row.item ? scope.row.item.code : ''}}</el-link>
            <span v-else>{{scope.row.item ? scope.row.item.code :''}}</span>
          </template>
    </vxe-column>
  <vxe-column
      field="nameCn"
      align="center"
      show-overflow
      title="中文名称">
      <template slot-scope="scope">
          <el-tooltip v-if="scope.row.itemId" class="item" effect="dark" :content="scope.row.item ? scope.row.item.nameCn : ''" placement="top">
            <div class="textOverflow">{{ scope.row.item ? scope.row.item.nameCn : '' }}</div>
          </el-tooltip>
          <el-tooltip v-else class="item" effect="dark" :content="scope.row.category ? scope.row.category.name : ''" placement="top">
            <div class="textOverflow">{{ scope.row.category ? scope.row.category.name : '' }}</div>
          </el-tooltip>
        </template>
    </vxe-column>
  <vxe-column
      field="name"
      align="center"
      title="英文名称">
      <template slot-scope="scope">
          <el-tooltip v-if="scope.row.itemId" class="item" effect="dark" :content="scope.row.item ? scope.row.item.name :''" placement="top">
            <div class="textOverflow">{{ scope.row.item ? scope.row.item.name : '' }}</div>
          </el-tooltip>
          <el-tooltip v-else class="item" effect="dark" :content="scope.row.category ? scope.row.category.nameEn : ''" placement="top">
            <div class="textOverflow">{{ scope.row.category ? scope.row.category.nameEn : '' }}</div>
          </el-tooltip>
        </template>
    </vxe-column>
    <vxe-column
        field="name"
        align="center"
        width="100"
        title="材料类别">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.item ? scope.row.item.category.parentIdsName : ''" placement="top">
            <div class="textOverflow">{{ scope.row.item ? scope.row.item.category.name : '' }}</div>
          </el-tooltip>
        </template>
      </vxe-column>
      <vxe-column
      field="num"
      align="center"
      width="100"
      title="单价">
      <template slot-scope="scope">
        <div class="flexBetween">
          <span>$</span>
          <div v-if="scope.row.item">
            <span>{{ scope.row.price }} / </span>   
            <span>{{ scope.row.item.units ? scope.row.item.units.unitEn : '' }}</span>
          </div>
        </div>
        </template>
    </vxe-column>
      
  <!-- <vxe-column
      field="minUsage"
      align="center"
      title="面积/数量">
    </vxe-column> -->
    <vxe-column
      field="rateNum"
      width="100"
      align="center"
      title="损耗率">
        <template slot-scope="scope">
          <span>{{ scope.row.rateNum }}%</span>
        </template>
    </vxe-column>
    <vxe-column
      field="picture"
      width="200"
      align="center"
      title="图片">
        <template slot-scope="scope">
            <PopoverTipList
              v-if="scope.row.picJsonList"
              labelValue = 'id'
              tableType = "length"
              tableHeight = '500px'
              boxWidth="200"
              :imageDisabled="true"
              :columns="[
              ]"
              :selectArray="scope.row.picJsonList"
            ></PopoverTipList>
            <span v-else>-</span>
          </template>
    </vxe-column>
  <vxe-column
      field="rateDesc"
      align="center"
      title="损耗率描述">
    </vxe-column>
  </vxe-table>
  </div>
  </div>
      <!-- 弹窗, 新增 / 修改 -->
  <CecItemForm  ref="cecItemForm" @refreshDataList="refreshList"></CecItemForm>
</div>
</template>

<script>
import CecItemForm from '../cecitem/CecItemForm.vue'
import csmpProjectService from '@/api/cecunmusersetmealproject/cecUnmUserSetMealProjectService'
import ItemService from '@/api/cecunmusersetmealprojectitem/cecUnmUserSetMealProjectItemService'
import GridSelect from '@/components/gridSelect/setItem.vue'
import PopoverTipList from '@/components/popoverTip/indexList.vue'
import CropperView from '@/components/upload/ImageUploadCropper.vue'
import othersUtils from '@/utils/othersUtils.js'
export default {
  data () {
    return {
      detForm: {
        unitEn: '',
        price: 0,
        description: '',
        unitCn: '',
        project: {
          proCode: '',
          name: ''
        }
      },
      dataList: [],
      tablePage: {
        orders: [{ column: 'sort', asc: false }]
      },
      loading: false,
      projectId: '',
      srcList: [],
      urlHearder: ''
    }
  },
  components: {
    CecItemForm,
    GridSelect,
    PopoverTipList,
    CropperView
  },
  activated () {
    this.urlHearder = localStorage.getItem('imageDomainName')
    this.projectId = this.$route.query.id
    this.refreshList()
  },
  methods: {
    //  upload image 上传图片
    changeImage (e, item) {
      if (e) {
        item.cover = typeof e === 'string' ? e : e.filePath
        item.coverImage = {
          actorId: e.actorId,
          actorName: e.actorName,
          fileName: e.fileName,
          category: 'setsProjectCover',
          filePath: typeof e === 'string' ? e : e.filePath
        }
        this.updataProjectCover(item)
      } else {
        item.cover = ''
      }
    },
    updataProjectCover (item) {
      let query = {
        id: item.id,
        coverImage: item.coverImage
      }
      csmpProjectService.save(query).then(({data}) => {
        this.$message.success('设置成功')
        this.refreshList()
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 获取数据列表
    refreshList () {
      // this.$refs.cropperviewRef.resetFields()
      this.detForm.cover = ''
      this.loading = true
      csmpProjectService.queryById(this.projectId).then(({data}) => {
        // this.inputForm = this.recover(this.inputForm, data)
        this.detForm = data
        this.detForm.unitCn = data.project.unit ? data.project.unit.unit : ''
        this.detForm.unitEn = data.project.unit ? data.project.unit.unitEn : ''
        this.loading = false
        if (data.coverImage) {
          this.detForm.cover = data.coverImage.filePath
        }
        if (data.picJson) {
          this.detForm.picJsonList = JSON.parse(data.picJson).map(citem => {
            let concatenatingUrls = this.urlHearder + citem.fileStorePath + citem.filesIn
            citem.fileUrl = concatenatingUrls
            this.srcList.push(concatenatingUrls)
            return citem
          })
        }
      })

      ItemService.list({
        positionProjectId: this.projectId,
        orders: [{ column: 'mate_kind', asc: true }],
        current: 1,
        size: 100
      }).then(({data}) => {
        this.dataList = data.records.map(item => {
          item.picJsonList = othersUtils.stitchingImages(item.item)
          return item
        })
      })
    },
    // 当前页
    currentChangeHandle ({ currentPage, pageSize }) {
      this.tablePage.currentPage = currentPage
      this.tablePage.pageSize = pageSize
      this.refreshList()
    },
    // 排序
    sortChangeHandle (obj) {
      this.tablePage.orders = []
      if (obj.order != null) {
        this.tablePage.orders = [{ column: obj.column.sortBy || this.$utils.toLine(obj.property), asc: obj.order === 'asc' }]
      } else {
        this.tablePage.orders = [{ column: 'create_date', asc: false }]
      }
      this.refreshList()
    },
    // 新增
    add () {
      this.$refs.cecUnmSetsForm.init('add', '')
    },
    // 修改
    edit (id) {
      id = id || this.$refs.cecUnmSetsTable.getCheckboxRecords().map(item => {
        return item.id
      })[0]
      this.$refs.cecUnmSetsForm.init('edit', id)
    },
    // 查看
    view (data) {
      let query = {
        id: data.itemId,
        parentCode: ''
      }
      this.$refs.cecItemForm.init('view', query)
    },
    resetSearch () {
      this.$refs.searchForm.resetFields()
      this.refreshList()
    }
  }
}
</script>
<style scoped>
.tableTitle{
  padding: 20px 0 10px 0;
  font-weight: bold;
}
.textOverflow{
  overflow: hidden;
  text-overflow: ellipsis;
}
.flexBetween{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>

